export default "__VITE_ASSET__DFvQKU_i__"